var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackupIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H35.9883C42.6157 0 47.9883 5.37258 47.9883 12V35.9883C47.9883 42.6157 42.6157 47.9883 35.9883 47.9883H12C5.37258 47.9883 0 42.6157 0 35.9883V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.9942C15 21.6088 15.9476 19.3211 17.6343 17.6343C19.3211 15.9476 21.6088 15 23.9942 15C26.5086 15.0095 28.922 15.9906 30.7298 17.7382L32.9883 19.9968",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.988 15V19.9967H27.9912",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9883 23.9941C32.9883 26.3795 32.0407 28.6672 30.354 30.354C28.6672 32.0407 26.3795 32.9883 23.9942 32.9883C21.4797 32.9788 19.0663 31.9977 17.2585 30.2501L15 27.9915",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9967 27.9916H15V32.9883",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackupIcon);
export default __webpack_public_path__ + "static/media/backup-icon.651c4b86253338dfdba43ea3ae266865.svg";
export { ForwardRef as ReactComponent };